import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-next.icon",
  "use": "besidaMob-next.icon-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"besidaMob-next.icon\"><path d=\"M22.875 60.375L16 54l20.125-22L16 10l6.875-6.375L48.5 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol